<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "Local Helper & Caregiver",

  metaInfo: { title: "Local Helper & Caregiver" },

  extends: View,

  mixins: [LoadSections(["hero-alt3", "Hero1", "contact-us", "info"])],

  props: {
    id: {
      type: String,
      default: "local-helper-caregiver"
    }
  }
};
</script>
